
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'ホーム', href: '/' },
    { name: '会社概要', href: '/about' },
    { name: '事業紹介', href: '/services' },
    { name: '理念・ビジョン', href: '/vision' },
    { name: 'お問い合わせ', href: '/contact' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm relative z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center relative overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/a106c164b1cd9064ddc9bc406a739a75/ab82e56affc3632b7b4f6221b96fd104.png" 
                  alt="MKF Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-2xl text-gray-800 font-bold">
                株式会社MKファシリティーズ
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-8">
              <Link 
                to="/about" 
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  isActive('/about') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                会社概要
              </Link>
              <Link 
                to="/services" 
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  isActive('/services') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                事業紹介
              </Link>
              <Link 
                to="/vision" 
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  isActive('/vision') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                理念・ビジョン
              </Link>
              <a 
                href="https://www.matsunaga.gr.jp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm font-medium transition-colors duration-200 text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap"
              >
                グループ
              </a>
              <Link 
                to="/contact" 
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  isActive('/contact') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                お問い合わせ
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="text-gray-700 hover:text-blue-600 cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`block px-3 py-2 text-base font-medium transition-colors duration-200 cursor-pointer ${
                    isActive(item.href)
                      ? 'text-blue-600 bg-blue-50'
                      : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="px-3 py-2">
                <Button size="sm" className="w-full whitespace-nowrap" asChild>
                  <Link to="/contact">お見積り依頼</Link>
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
